(function () {
  'use strict';

  var ALLOWED_EXTS  = ['.pdf', '.jpg', '.jpeg', '.png', '.csv', '.xls', '.xlsx'];
  var ALLOWED_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  var submitting = false;

  // Hard-coded ceilings matching the certified backend contract.
  // These cannot be overridden by the Theme Editor — they reflect actual
  // Vercel platform limits, not aspirational figures.
  var HARD_PER_FILE_BYTES  = 3 * 1024 * 1024;               // 3 MiB per file
  var HARD_AGGREGATE_BYTES = 3 * 1024 * 1024 + 512 * 1024;  // 3.5 MiB total attachments

  function init() {
    var root = document.getElementById('gbp-root');
    if (!root) return;

    var form      = document.getElementById('gilgal-business-pricing-form');
    var submitBtn = document.getElementById('gbp-submit-btn');
    // Theme Editor setting is honoured only if it is BELOW the certified ceiling.
    var maxBytes  = Math.min(
      parseInt(root.dataset.maxMb || '3', 10) * 1024 * 1024,
      HARD_PER_FILE_BYTES
    );

    if (!form || !submitBtn) return;

    // ── Phone auto-format: (###) ###-#### ──────────────────────────────────
    var phoneInput = form.querySelector('input[name="phone"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var fmt = formatPhone(phoneInput.value);
        if (fmt !== phoneInput.value) phoneInput.value = fmt;
      });
    }

    // ── "Other" reveal: facility type ─────────────────────────────────────
    setupOtherReveal(
      form.querySelector('select[name="facility_type"]'),
      document.getElementById('gbp-facility-type-other-wrap')
    );

    // ── File input: show filename, validate on change ─────────────────────
    root.querySelectorAll('.gii-upload-box').forEach(function (box) {
      var input       = box.querySelector('input[type="file"]');
      var primaryText = box.querySelector('.gii-upload-text__primary');
      var defaultTxt  = primaryText ? primaryText.textContent : '';
      var item        = box.closest('.gii-upload-item');
      var uploadErr   = item ? item.querySelector('.gii-upload__error') : null;

      if (!input) return;

      input.addEventListener('change', function () {
        var file = input.files[0];
        clearUploadError(box, uploadErr);

        if (!file) {
          box.classList.remove('gii-upload-box--has-file', 'gii-upload-box--error');
          if (primaryText) primaryText.textContent = defaultTxt;
          return;
        }

        var err = fileError(file, maxBytes);
        if (err) {
          box.classList.add('gii-upload-box--error');
          box.classList.remove('gii-upload-box--has-file');
          showErr(uploadErr, err);
          input.value = '';
          if (primaryText) primaryText.textContent = defaultTxt;
        } else {
          box.classList.add('gii-upload-box--has-file');
          if (primaryText) primaryText.textContent = file.name;
        }
      });
    });

    // ── Submit ─────────────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (submitting) return;
      if (validate(root, maxBytes) > 0) return;

      var endpoint = root.dataset.endpoint;

      if (!endpoint) {
        showFormError(root, 'Submission endpoint is not configured. Please contact support.');
        return;
      }

      submitting = true;
      setLoading(submitBtn, true);
      clearFormError(root);

      var formData = new FormData(form);

      // Replace "Other" facility_type with the free-text value
      resolveOther(form, formData, 'facility_type', 'facility_type_other');

      // Turnstile token is included automatically by the widget
      // (cf-turnstile-response is added to the form by the Turnstile script)

      // No x-api-key header — relay authentication is handled server-side by the Worker
      fetch(endpoint, { method: 'POST', body: formData })
        .then(function (res) {
          return res.json().then(function (data) {
            return { status: res.status, data: data };
          });
        })
        .then(function (result) {
          setLoading(submitBtn, false);
          submitting = false;

          if (result.status === 200 && result.data.ok) {
            form.style.display = 'none';
            var successEl = document.getElementById('gbp-success');
            if (successEl) {
              // Inject request number into success message if present
              if (result.data.request_number) {
                var bodyEl = successEl.querySelector('.gii-message__body');
                if (bodyEl) {
                  bodyEl.insertAdjacentHTML(
                    'beforeend',
                    '<br><strong>Reference: ' + result.data.request_number + '</strong>'
                  );
                }
              }
              successEl.style.display = 'block';
              successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
          }

          // Error responses
          var msg;
          if (result.status === 401 || result.status === 403) {
            msg = 'We could not verify your request. Please try again or call us at (855) 228-3625.';
          } else if (result.status === 413) {
            msg = 'Your attachments are too large. Please reduce the file size and try again.';
          } else if (result.status === 422) {
            msg = result.data.error || 'Some required fields are missing. Please review your entries.';
          } else {
            msg = 'We could not submit your request. Please try again or call us at (855) 228-3625.';
          }
          showFormError(root, msg);
        })
        .catch(function () {
          setLoading(submitBtn, false);
          submitting = false;
          showFormError(root, 'A network error occurred. Please check your connection and try again.');
        });
    });
  }

  // ── Phone formatting ─────────────────────────────────────────────────────

  function formatPhone(raw) {
    var digits = raw.replace(/\D/g, '').slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 7) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  // ── "Other" reveal ───────────────────────────────────────────────────────

  function setupOtherReveal(select, wrapEl) {
    if (!select || !wrapEl) return;
    function update() {
      var show = select.value === 'Other';
      wrapEl.style.display = show ? '' : 'none';
      var input = wrapEl.querySelector('input, textarea');
      if (input) {
        if (show) {
          input.setAttribute('data-required', '');
          input.setAttribute('aria-required', 'true');
        } else {
          input.removeAttribute('data-required');
          input.removeAttribute('aria-required');
          input.value = '';
          clearFieldError(input, wrapEl.querySelector('.gii-field__error'));
        }
      }
    }
    select.addEventListener('change', update);
    update();
  }

  function resolveOther(form, formData, selectName, otherName) {
    var select = form.querySelector('select[name="' + selectName + '"]');
    if (!select || select.value !== 'Other') {
      formData.delete(otherName);
      return;
    }
    var otherInput = form.querySelector('[name="' + otherName + '"]');
    var otherVal   = otherInput ? otherInput.value.trim() : '';
    formData.set(selectName, otherVal || 'Other');
    formData.delete(otherName);
  }

  // ── Validation ───────────────────────────────────────────────────────────

  function validate(root, maxBytes) {
    var errors = 0;

    // Required text / select / textarea (upload box divs excluded)
    root.querySelectorAll('input[data-required], select[data-required], textarea[data-required]').forEach(function (el) {
      var wrap  = el.closest('.gii-field');
      var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
      clearFieldError(el, errEl);
      var val = typeof el.value === 'string' ? el.value.trim() : '';
      if (!val) {
        setFieldError(el, errEl, el.dataset.errorMsg || 'This field is required.');
        errors++;
      }
    });

    // Format validators — only run if field has a value and wasn't already flagged
    errors += runFormatCheck(root, 'phone', validatePhone);
    errors += runFormatCheck(root, 'email', validateEmail);
    errors += runFormatCheck(root, 'zip',   validateZip);

    // Optional file uploads — validate each individually, then check aggregate
    var totalAttachBytes = 0;
    root.querySelectorAll('.gii-upload-box').forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      if (!input || !input.files || !input.files[0]) return;
      var item  = box.closest('.gii-upload-item');
      var errEl = item ? item.querySelector('.gii-upload__error') : null;
      var err   = fileError(input.files[0], maxBytes);
      if (err) {
        box.classList.add('gii-upload-box--error');
        showErr(errEl, err);
        errors++;
      } else {
        totalAttachBytes += input.files[0].size;
      }
    });

    // Aggregate check — all individual files passed but combined they exceed
    // the total attachment budget (3.5 MB). This prevents multi-file oversize
    // even when each file is individually below the per-file limit.
    if (errors === 0 && totalAttachBytes > HARD_AGGREGATE_BYTES) {
      showFormError(root, 'Combined attachments exceed the 3.5 MB total limit. Please use smaller files or attach fewer files.');
      errors++;
    }

    if (errors > 0) {
      var first = root.querySelector('[aria-invalid="true"], .gii-upload-box--error');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return errors;
  }

  function runFormatCheck(root, name, fn) {
    var el = root.querySelector('[name="' + name + '"]');
    if (!el) return 0;
    var val = typeof el.value === 'string' ? el.value.trim() : '';
    if (!val) return 0;
    if (el.getAttribute('aria-invalid') === 'true') return 0;
    var wrap  = el.closest('.gii-field');
    var errEl = wrap ? wrap.querySelector('.gii-field__error') : null;
    var err   = fn(val);
    if (err) { setFieldError(el, errEl, err); return 1; }
    return 0;
  }

  function validatePhone(val) {
    if (val.replace(/\D/g, '').length !== 10) return 'Please enter a valid 10-digit phone number.';
    return null;
  }

  function validateEmail(val) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return 'Please enter a valid email address.';
    return null;
  }

  function validateZip(val) {
    if (!/^\d{5}(-\d{4})?$/.test(val)) return 'Please enter a valid ZIP code (e.g. 33101 or 33101-1234).';
    return null;
  }

  function fileError(file, maxBytes) {
    var ext    = (file.name.match(/\.[^.]+$/) || [''])[0].toLowerCase();
    var okExt  = ALLOWED_EXTS.indexOf(ext) > -1;
    var okMime = ALLOWED_TYPES.indexOf(file.type) > -1;
    if (!okExt && !okMime) return 'Only PDF, JPG, PNG, CSV, XLS, and XLSX files are accepted.';
    if (file.size > maxBytes) return 'File exceeds ' + Math.round(maxBytes / 1048576) + 'MB limit.';
    return null;
  }

  // ── DOM helpers ──────────────────────────────────────────────────────────

  function setFieldError(el, errEl, msg) {
    el.setAttribute('aria-invalid', 'true');
    showErr(errEl, msg);
  }
  function clearFieldError(el, errEl) {
    el.removeAttribute('aria-invalid');
    clearErr(errEl);
  }
  function clearUploadError(box, errEl) {
    box.classList.remove('gii-upload-box--error');
    clearErr(errEl);
  }
  function showErr(el, msg)  { if (el) { el.textContent = msg; el.classList.add('gii-visible'); } }
  function clearErr(el)      { if (el) { el.textContent = '';  el.classList.remove('gii-visible'); } }

  function setLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('gii-submit-btn--loading', on);
    var txt = btn.querySelector('.gii-submit-btn__text');
    if (txt) txt.textContent = on ? 'Sending Request…' : 'Request Pricing';
  }

  function showFormError(root, msg) {
    var el = root.querySelector('#gbp-form-error');
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearFormError(root) {
    var el = root.querySelector('#gbp-form-error');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
